import React from "react";

import { Col, Row, Stack } from "react-bootstrap";

import classNames from "classnames";

import { ResaleFragment } from "@api/graphql";
import styles from "@pages/dashboard/DetailsDrawer.module.scss";
import { formatISODateToFormat } from "@util/index";

import { DetailCell } from "../resale_submission/DetailCell";

import { FieldFormatter } from "./FieldFormatter";

const REPORTING_DETAILS_FORMATTERS: FieldFormatter<ResaleFragment>[] = [
  { title: "Reported by", format: (resale) => resale.reporter_name || "-" },
  {
    title: "Date",
    format: (resale) => formatISODateToFormat({ isoDate: resale?.reported_on || "", targetDateFormat: "DD/MM/YYYY" }),
  },
];
interface ReportingDetailsProps {
  resale: ResaleFragment;
}
export const ReportingDetailsDrawer = ({ resale }: ReportingDetailsProps) => (
  <Stack gap={4} className="col-md-10">
    <Row>
      <span className={classNames(styles["stack-label"], "h5")}>Reporting details</span>
    </Row>
    <Row>
      {resale &&
        REPORTING_DETAILS_FORMATTERS.map(({ title, format }) => (
          <Col md={6} className={styles["detail"]} key={title}>
            <DetailCell title={title} value={format(resale)} />
          </Col>
        ))}
    </Row>
  </Stack>
);
